import { cva } from 'class-variance-authority'

export const titleStyles = cva(
  `
    flex
    inline-flex
    text-neutral-900
  `,
  {
    variants: {
      error: {
        true: `
          text-danger-100
        `,
      },
      disabled: {
        true: `
          text-neutral-400
          cursor-not-allowed
        `,
      },
    },
    defaultVariants: {
      error: false,
      disabled: false,
    },
  }
)

export const optionalTextStyles = cva(
  `
    inline-flex
    pl-1
    text-neutral-500
  `,
  {
    variants: {
      error: {
        true: `
          text-danger-50
        `,
      },
      disabled: {
        true: `
          text-neutral-300
          cursor-not-allowed
        `,
      },
    },
    defaultVariants: {
      error: false,
      disabled: false,
    },
  }
)

export const descriptionStyles = cva(
  `
    mt-0.5
    mb-3
    text-neutral-600
  `,
  {
    variants: {
      error: {
        true: `
          text-danger-100
        `,
      },
      disabled: {
        true: `
          text-neutral-400
          cursor-not-allowed
        `,
      },
    },
    defaultVariants: {
      error: false,
      disabled: false,
    },
  }
)
